export default {
	computed: {
		_vdocumento() {
			return $cliente.get('mascara_documento')
		},

		_vtelefone() {
			return $cliente.get('mascara_telefone')
		},

		_vcelular() {
			return _.isNil($cliente.get('mascara_celular'))
				? $cliente.get('mascara_telefone')
				: $cliente.get('mascara_celular')
		},

		_vcep() {
			return $cliente.get('mascara_cep')
		},

		_vcnpj() {
			return '00.000.000/0000-00'
		},
    
		_vmoney() {
			//<money v-model="form.carga_horaria" v-bind="_vmoney" class="form-control input-sm"></money>
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				prefix: lg['sifrao'] + ' ',
				suffix: '',
				precision: 2,
				masked: false
			}
		},

		_vmoneyCombustivel() {
			//<money v-model="form.carga_horaria" v-bind="_vmoney" class="form-control input-sm"></money>
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				prefix: lg['sifrao'] + ' ',
				suffix: '',
				precision: 3,
				masked: false
			}
		},

		_vdecimalMoedaReal() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				prefix: lg['sifrao'] + '',
				suffix: '',
				precision: 2,
				masked: false
			}
		},

		_vdecimalMoedaDolar() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				prefix: '$',
				suffix: '',
				precision: 2,
				masked: false
			}
		},

		_vdecimal() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				suffix: '',
				precision: 1,
				masked: false
			}
		},

		_vdecimalTres() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				suffix: '',
				precision: 3,
				masked: false
			}
		},
		
		_vdecimalDois() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				suffix: '',
				precision: 2,
				masked: false
			}
		},

		_vdecimalParalelo() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				suffix: '',
				precision: 2,
				masked: false
			}
		},

		_vDecimalCinco() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))

			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				suffix: '',
				precision: 5,
				masked: false
			}
		},

		_vInteiro() {
			return {
				decimal: '',
				thousands: '',
				precision: 0,
				masked: false
			}
		},
	},

	methods: {
		_vinteiro(tamanho) {
			var retorno = ''
			for (var i = 1; i <= tamanho; i++) {
				retorno += '0'
			}
			return retorno
		},

		_vpercem(casa, prefix, suffix) {
			let _prefix = ''
			let _suffix = ''

			if (!_.isNil(prefix)) {
				_prefix = prefix
			}

			if (!_.isNil(suffix)) {
				_suffix = suffix
			}
			

			//<money v-model="form.carga_horaria" v-bind="_vpercem(1)" class="form-control input-sm"></money>
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))
			return {
				decimal: lg['decimal'],
				thousands: lg['milhar'],
				prefix: _prefix,
				suffix: _suffix,
				precision: Number(casa),
				masked: false
			}
		}
	}
}